import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
// import { HelmetIcon } from '../../ctIcons'
import { tableLoader } from '@shared/libs/allLoader'
import BatterDataRow from './BatterDataRow'
import useStatus from '@shared-submodule/sm-hooks/useStatus'

const ThemeTable = dynamic(() => import('@shared/components/themeTable'), { loading: () => tableLoader() })

const ScorecardTable = ({ data, fullSquad, matchDetail, is100, currentTeam }) => {
  const { sStatusStr } = useStatus(matchDetail)

  const labels = [
    `${'Batter'}`,
    <>
      <span className="d-none d-sm-inline" key={'runs'}>
        {'Runs'}
      </span>
      <span className="d-sm-none" key={'r'}>
        {'R'}
      </span>
    </>,
    <>
      <span className="d-none d-sm-inline" key={'balls'}>
        {'Balls'}
      </span>
      <span className="d-sm-none" key={'b'}>
        {'B'}
      </span>
    </>,
    `${'4s'}`,
    `${'6s'}`,
    `${'SR'}`
  ]
  const table = useRef({ nRuns: 'Runs', nBallFaced: 'Balls', nFours: '4s', nSixes: '6s', sStrikeRate: 'SR' })
  const playingXIMember = useRef()
  let res = []
  const [result, setResult] = useState()
  const [capwk, setCapWk] = useState()
  playingXIMember.current = fullSquad.filter(data => data.bPlaying11 === true)
  const team1PlayingPlayerData = playingXIMember.current.filter(item => item?.oTeam?._id === data?.iBattingTeamId)
  const team2PlayingPlayerData = playingXIMember.current.filter(item => item?.oTeam?._id !== data?.iBattingTeamId)
  const filterForYetToBat = (arr1, arr2) => {
    res = arr1.filter(el => {
      return !arr2.aBatters.find(element => {
        return element?.iBatterId === el.iPlayerId
      })
    })
    setResult(res)
  }

  const filterForCapWk = (arr1, arr2) => {
    res = arr1.filter(el => {
      return arr2.aBatters.find(element => {
        if (el.iPlayerId === element?.iBatterId && (el.sRoleStr === 'cap' || el.sRoleStr === 'wk' || el.sRoleStr === 'wkcap')) {
          return el
        } else {
          return null
        }
      })
    })
    setCapWk(res)
  }

  useEffect(() => {
    if (data?.iBattingTeamId === team1PlayingPlayerData[0]?.oTeam?._id) {
      filterForYetToBat(team1PlayingPlayerData, data)
    } else {
      filterForYetToBat(team2PlayingPlayerData, data)
    }
  }, [])

  function getPlayersByRole(players, role) {
    let firstPlayer
    const otherPlayers = []

    for (const player of players) {
      if (player.sRoleStr === role) {
        firstPlayer = player
      } else {
        otherPlayers.push(player)
      }
    }

    return [firstPlayer, ...otherPlayers]
  }

  useEffect(() => {
    if (data?.iBattingTeamId === team1PlayingPlayerData[0]?.oTeam?._id) {
      filterForCapWk(team1PlayingPlayerData, data)
    } else {
      filterForCapWk(team2PlayingPlayerData, data)
    }
  }, [])

  const playersByRole = result?.length ? getPlayersByRole(result, 'bat') : []

  return (
    <div className={`${styles.scorecardTable}`}>
      <ThemeTable labels={labels} isBordered={true}>
        {data?.aBatters?.map((batter, index) => {
          return <BatterDataRow currentTeam={currentTeam} matchDetail={matchDetail} key={index} batter={batter} table={table} capwk={capwk} />
        })}
        <tr>
          {result?.length > 0 && (
            <td colSpan="6" className={`${styles.YetToBat}`}>
              {sStatusStr === 'completed' || data.nInningNumber !== matchDetail?.nLatestInningNumber ? (
                <span className={`${styles.footerLabel} font-bold`}>{'Did not bat'} </span>
              ) : (
                <span className={`${styles.footerLabel} font-bold`}>{'Yet To Bat'} : </span>
              )}
              <span className={`${styles.subText} text-wrap ms-1`}>
                {result?.length > 0 ? playersByRole?.map((ytb, index) => (
                  <span key={index}>
                    {ytb?.sName}
                    {ytb?.sRoleStr === 'wk' && ` (${'wk'})`}
                    {ytb?.sRoleStr === 'cap' && ` (${'c'})`}
                    {ytb?.sRoleStr === 'wkcap' && ` (${'c & wk'})`}
                    {playersByRole.length - 1 === index || !ytb?.sName ? '' : ', '}
                  </span>
                )) : ' - '}
              </span>
            </td>
          )}
        </tr>
        <tr>
          <td className="font-bold">
            <span className="d-flex flex-column flex-md-row">
              <span className={`${styles.footerLabel}`}>{'Extra'}</span>
              <span className={`${styles.subText} text-uppercase`}>
                {'b'} - {data?.oExtraRuns?.nByes}, {'w'} - {data?.oExtraRuns?.nWides}, {'no'} -{' '}
                {data?.oExtraRuns?.nNoBalls}, {'lb'} - {data?.oExtraRuns?.nLegByes}, {'p'} -{' '}
                {data?.oExtraRuns?.nPenalty === null ? '0' : data?.oExtraRuns?.nPenalty}
              </span>
            </span>
          </td>
          <td>{data?.oExtraRuns?.nTotal}</td>
          <td colSpan="4"> </td>
        </tr>
        <tr>
          <td className="font-bold">
            <span className="d-flex flex-column flex-md-row">
              <span className={`${styles.footerLabel}`}>{'Total'}</span>
              {!is100 && (
                <span className={`${styles.subText}`}>
                  {data?.oEquations?.sRunRate} {'Runs per over'}
                </span>
              )}
            </span>
          </td>
          <td>
            {data?.oEquations?.nRuns}
            {data?.oEquations?.sOvers &&
              data?.oEquations?.nWickets >= 0 &&
              ` (${data?.oEquations?.nWickets} ${'Wkts'}, ${data?.oEquations?.sOvers} ${is100 ? 'B' : 'Ov'})`}
          </td>
          <td colSpan="4"> </td>
        </tr>
      </ThemeTable>
    </div>
  )
}

ScorecardTable.propTypes = {
  data: PropTypes.object,
  fullSquad: PropTypes.array,
  matchDetail: PropTypes.object,
  is100: PropTypes.bool,
  currentTeam: PropTypes.number
}

export default ScorecardTable
